import { createQueryParams } from '@nexio/emvio-util-app';

export const CSV_LOAD = 'CSV/CSV_LOAD';
export const CSV_SUCCESS = 'CSV/CSV_SUCCESS';
export const CSV_FAILURE = 'CSV/CSV_FAILURE';

export function getCSVSuccessActionCreator(tableName, sorters) {
    return (result) => {
        return {
            tableName,
            hasMore: result.hasMore,
            csvData: result.rows,
            sorters,
            type: CSV_SUCCESS
        };
    };
}

export function getCSVFailureActionCreator(error) {
    return {
        error,
        type: CSV_FAILURE
    };
}

export function getCSV(fetchUrl, merchantIds, columns, filters, sorters, dateKey, tableName) {
    const pageSize = tableName === 'Transactions' ? 2500 : 5000;

    const queryParamsString = createQueryParams({
        columns,
        dateKey,
        filters,
        merchantIds,
        page: 0,
        pageSize
    });

    return {
        failureActionTypeOrCreator: getCSVFailureActionCreator,
        fetchParams: {
            url: `${fetchUrl}${queryParamsString}`
        },
        loadActionTypeOrCreator: CSV_LOAD,
        successActionTypeOrCreator: getCSVSuccessActionCreator(tableName, sorters)
    };
}
